import React, { memo, useContext, useState } from "react";

import { withRouter } from "react-router";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import { tienePermisoRuta } from "../../../../config/validaciones";
import AuthContext from "../../../../Context/Auth/AuthContext";
import MenuContext from "../../../../Context/Menu/MenuContext";
import { serverphp, permisoDenagado } from "../../../../config/const";
import ButtonsActionsDialog from "./ButtonsActionsDialog";
// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  TableCell,
  Tooltip,
} from "@mui/material";
import {
  Cancel,
  Check,
  Create,
  PictureAsPdf,
  ListRounded,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  margin: {
    margin: "0px",
    padding: "2px",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));

const ButtonsAction = (props) => {
  const {
    arrayExport,
    setarrayExport,
    campoExport,
    row,
    setopenConfirmDialog,
    funcionEdit,
    ocultarEditar,
    // ocultarDelete,
    mostrarEstado,
    campoEstado,
    editar,
    funcCancel,
    funcSubmit,
    botonDisabled,
    setopenModalEmail,
    expandir,
    setexpandir,
    socket,
  } = props;
  const classes = useRowStyles();
  const { usuario } = useContext(AuthContext);
  const { rows } = useContext(MenuContext);
  const { mostrarAlerta } = useContext(AlertaContext);
  const [open, setopen] = useState(false);
  return (
    <>
      <ButtonsActionsDialog
        sock
        open={open}
        setopen={setopen}
        setopenConfirmDialog={setopenConfirmDialog}
        row={row}
        setopenModalEmail={setopenModalEmail}
        socket={socket}
      />
      {arrayExport ? (
        <TableCell
          size="small"
          padding="checkbox"
          style={{
            borderRight: "1px solid #ccc",
            maxWidth: "1rem",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <FormControlLabel
              className={classes.margin}
              control={
                <Checkbox
                  size="small"
                  className={classes.margin}
                  checked={arrayExport.some((item) => {
                    return item[campoExport] === row[campoExport];
                  })}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setarrayExport([...arrayExport, row]);
                    } else {
                      setarrayExport(
                        arrayExport.filter(
                          (item) => item[campoExport] !== row[campoExport]
                        )
                      );
                    }
                  }}
                  color="secondary"
                />
              }
            />
          </Box>
        </TableCell>
      ) : null}
      <TableCell padding="none" style={{ borderRight: "1px solid #ccc" }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-around"
          ml={1}
          mr={1}
        >
          <>
            {editar ? (
              <>
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    funcCancel();
                  }}
                >
                  <Cancel fontSize="small" color="secondary" />
                </IconButton>
                <IconButton
                  className={classes.margin}
                  disabled={botonDisabled ? botonDisabled() : false}
                  onClick={() => {
                    funcSubmit();
                  }}
                >
                  <Check
                    fontSize="small"
                    color={
                      botonDisabled
                        ? botonDisabled()
                          ? "inherit"
                          : "secondary"
                        : "secondary"
                    }
                  />
                </IconButton>
              </>
            ) : (
              <>
                {ocultarEditar ? null : (
                  <IconButton
                    className={classes.margin}
                    onClick={() => {
                      if (
                        !tienePermisoRuta(
                          rows,
                          props.location.pathname,
                          usuario.rol,
                          "editar"
                        )
                      ) {
                        return mostrarAlerta(permisoDenagado, "error");
                      }
                      funcionEdit();
                    }}
                  >
                    <Create color="secondary" />
                  </IconButton>
                )}
                <Tooltip title="PasdaDF" arrow>
                  <IconButton
                    className={classes.margin}
                    disabled={
                      !(
                        row.estado === "AUTORIZADO" ||
                        row.estado === "ANULADA" ||
                        row.estado === "SIN AUTORIZAR" ||
                        row.estado === "PROCESADO" ||
                        row.estado === "GASTOS PERSONALES"
                      )
                    }
                    style={{
                      color:
                        row.estado === "AUTORIZADO" ||
                        row.estado === "ANULADA" ||
                        row.estado === "SIN AUTORIZAR" ||
                        row.estado === "PROCESADO" ||
                        row.estado === "GASTOS PERSONALES"
                          ? "#f44336"
                          : "",
                    }}
                    onClick={() => {
                      // Abres la nueva ventas
                      window.open(
                        `${serverphp}reportes/retencion.php?codigo=${row.compId}&empresa=${usuario.rucempresa}`,
                        "_blank"
                      );
                    }}
                  >
                    <PictureAsPdf />
                  </IconButton>
                </Tooltip>
                {/* {Object.keys(row.compOtros).length} */}
                <Tooltip title="FACTURA COMPRA" arrow>
                  <IconButton
                    className={classes.margin}
                    color="secondary"
                    disabled={Object.keys(row.compOtros).length === 0}
                    onClick={() => {
                      // Abres la nueva ventas
                      window.open(
                        `${serverphp}reportes/factura_compra.php?codigo=${row.compId}&empresa=${usuario.rucempresa}`,
                        "_blank"
                      );
                    }}
                  >
                    <PictureAsPdf />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Mas acciones" arrow>
                  <IconButton
                    className={classes.margin}
                    onClick={() => {
                      setopen(true);
                    }}
                  >
                    <ListRounded />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </>
          {mostrarEstado ? (
            <FormControlLabel
              disabled
              className={classes.margin}
              control={
                <Checkbox
                  value="ACTIVO"
                  className={classes.margin}
                  checked={
                    row[campoEstado] === "ACTIVA" ||
                    row[campoEstado] === "ACTIVO"
                      ? true
                      : false
                  }
                  color="primary"
                />
              }
            />
          ) : null}
          {expandir ? (
            <IconButton
              className={classes.margin}
              onClick={() => {
                setexpandir(false);
              }}
            >
              <ExpandLess color="secondary" />
            </IconButton>
          ) : (
            <IconButton
              className={classes.margin}
              onClick={() => {
                setexpandir(true);
              }}
            >
              <ExpandMore color="secondary" />
            </IconButton>
          )}
        </Box>
      </TableCell>
    </>
  );
};

export default withRouter(memo(ButtonsAction));
